export default __webpack_public_path__ + "static/media/s1.42b4b5da.svg";